import { getPackageById } from '@/lib/packages';

export const PackageUpgradeNote = () => {
  const pro = getPackageById('guard-pro');
  const elite = getPackageById('guard-elite');
  const difference = Number(elite.price.replace(/\D/g, '')) - Number(pro.price.replace(/\D/g, ''));
  const formatted = `RM${difference.toLocaleString('en-MY')}`;
  return <div className="gg-upgrade-note" data-testid="pro-elite-comparison">
    <h3 data-testid="pro-elite-comparison-heading">Pro atau Elite? Kedua-duanya 8 kamera.</h3>
    <p data-testid="pro-elite-comparison-copy"><strong>Pro:</strong> ColorVu 4MP + HDD 2TB. <strong>Elite, tambah {formatted}:</strong> 5MP, AcuSense untuk menapis manusia/kenderaan, HDD 4TB serta strobe dan two-way audio pada kamera terpilih.</p>
    <p className="gg-upgrade-qualification" data-testid="pro-elite-storage-note">HDD lebih besar bukan jaminan tempoh rakaman berganda; tempohnya ikut tetapan dan aktiviti kamera.</p>
  </div>;
};